<script>
	import Data from "../controladores/data.svelte";
	import {pop} from "svelte-spa-router";
	export let params;
	let controlador;
	let vacuna = "";
	let vacunas = [
		{nombre:"Quintuple",caducidad:100},
		{nombre:"Séxtuple",caducidad:12},
		{nombre:"Rabia",caducidad:12},
		{nombre:"Bordetella Bronchiseptica",caducidad:6},
		{nombre:"Desparasitación",caducidad:6},
		{nombre:"Triple Felina",caducidad:12}
	];
	function agregar(){
		controlador.agregarVacuna(params.documento,vacuna.nombre,vacuna.caducidad);
	}
	function volver(){
		pop();
	}
</script>
<Data bind:this={controlador} />
<div class="flex flex-col bg-purple-300 items-center justify-start w-screen h-screen max-w-full max-h-full">
	<h1 class="text-xl font-bold m-2">Nueva Vacuna</h1>
	<select  class="w-3/4 p-2 m-2" bind:value={vacuna}>
		{#each vacunas as v}
			<option value={v}>{v.nombre}</option>
		{/each}
	</select>
	<div class="flex items-center justify-between w-3/4">
		<button on:click={volver} class="m-2 p-2 text-white bg-purple-500 flex items-center justify-center rounded cursor-pointer">Volver</button>
		<button on:click={agregar} class="m-2 p-2 text-white bg-purple-500 flex items-center justify-center rounded cursor-pointer">Agregar</button>
	</div>	
</div>
